import { ExitMeetingPageComponent } from "./exit-meeting-page.component";
export const ExitMeetingPageModule = angular
    .module('exitMeetingPage', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('exitMeeting', {
            url: '/exitMeeting',
            component: ExitMeetingPageComponent.selector,
            data: {
                requireLogin: false
            }
        });
    }
])
    .component(ExitMeetingPageComponent.selector, ExitMeetingPageComponent.component)
    .name;
//# sourceMappingURL=exit-meeting-page.module.js.map